"use client";

import { useState } from "react";
import { motion } from "framer-motion";
import { cn } from "@/lib/utils";
import { fallbackImages } from "@/data/mockImages";

const MarqueeImage = ({ src, alt }: { src: string; alt: string }) => {
  const [imgSrc, setImgSrc] = useState(src);

  return (
    <motion.img
      whileHover={{ scale: 1.1 }}
      transition={{
        duration: 0.3,
        ease: "easeInOut",
      }}
      src={imgSrc}
      alt={alt}
      onError={() => setImgSrc(fallbackImages.logo)}
      className="w-24 h-24 sm:w-32 sm:h-32 lg:w-40 lg:h-40 rounded-xl object-contain bg-card/30 p-3 ring-1 ring-border/20 hover:shadow-xl hover:shadow-primary/20 transition-all backdrop-blur-sm"
    />
  );
};

export const ThreeDMarquee = ({
  images,
  className,
}: {
  images: { src: string; alt: string }[];
  className?: string;
}) => {
  // Duplicar imagens para efeito infinito
  const displayImages = [...images, ...images];

  return (
    <div
      className={cn(
        "w-full overflow-hidden py-8",
        className
      )}
    >
      {/* Container com perspectiva 3D */}
      <div className="relative flex justify-center items-center [perspective:1000px]">
        <motion.div
          style={{
            transformStyle: "preserve-3d",
            transform: "rotateX(15deg)",
          }}
          className="flex flex-wrap justify-center items-center gap-4 sm:gap-6 lg:gap-8 max-w-5xl mx-auto px-4"
        >
          {displayImages.map((image, index) => (
            <motion.div
              key={`${image.alt}-${index}`}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{
                duration: 0.5,
                delay: index * 0.1,
                ease: "easeOut",
              }}
              whileHover={{
                z: 50,
                transition: { duration: 0.2 }
              }}
              className="transform-gpu"
            >
              <MarqueeImage src={image.src} alt={image.alt} />
            </motion.div>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default ThreeDMarquee;
